import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface Poi {
  category: string;
  creationDate: string;
  description: string;
  detailDescription: string;
  id: number;
  lat?: string;
  lon?: string;
  municipality: string;
  name: string;
  link?: string;
  price?: string;
  tags: string;
  userId: number;
  images?: string;
  imageOrder?: string;
  validated?: string;
  orderNumber: number;
}

@Injectable({
  providedIn: 'root'
})
export class PoiService {
  constructor(private http: HttpClient) { }

  loadPois() {
   return this.http.get<Poi[]>(environment.baseUrl + environment.endpoints.poi);
  }

  loadPoi(id: number) {
    return this.http.get<Poi>(environment.baseUrl + environment.endpoints.poi + '/' + id);
  }
}
